<template>
    <div class="page white_bg" style="padding-bottom: 40px;">

        <div class="pageBg fullSpace">
            <img src="salesPromotion/trial_vip_bg.svg" alt=""/>
        </div>

        <div class="pageContent fullSpace">
            <div style="padding: 284px 16px 0;">

                <div class="white_bg roundBorder8">
                    <div class="padding20">

                        <div class="color333 font20r bold lineHeight30r20">送您3天VIP体验</div>

                        <!-- 分隔线 -->
                        <div style="margin: 12px 0;">
                            <div style="width:41px; height:2px; background:rgba(255,178,0,1); border-radius:1px;"></div>
                        </div>

                        <div class="bottomBorderFAFAFA" style="padding-bottom: 12px;">
                            <input type="text" class="block lineHeight24r16 color333 font16r bold noBorder placeholderColorCCC"
                            placeholder="请输入手机号" v-model="phone"/>
                        </div>

                        <div class="bottomBorderFAFAFA lineHeight24r16" style="padding: 12px 0;">
                            <div class="flexLayout">
                                <div class="flexItem">
                                    <input type="text" class="block lineHeight24r16 font16r color333 bold noBorder placeholderColorCCC"
                                    placeholder="请输入验证码" v-model="validateIdentifyingCode"/>
                                </div>
                                <div class="alignRight" style="width: 6em;">
                                    <button class="getCodeButton font16r bold" :disabled="phone.length < 1">获取验证码</button>
                                </div>
                            </div>
                        </div>

                        <div class="paddingT20 paddingH16">
                            <button class="submitButton block font16r white bold">免费领取</button>
                        </div>

                    </div>
                </div>

                <!-- 会员介绍 -->
                <div class="white">
                    <div class="paddingT16 paddingB8 lineHeight24r16">
                        会员介绍
                    </div>
                    <ul class="noPadding noMargin noListStyle font14r lineHeight21r14">
                        <li>1、会员开通后可享受专属服务。</li>
                        <li>2、解锁资料课程，平台海量部分课程及素材免费。</li>
                    </ul>
                </div>


            </div>
        </div>

    </div>
</template>

<script>
import generalCmpPart from '@comp/part/generalCmpPart';

// utils
import appHelper        from '@util/appHelper';

const config = {
    apiConfig : {
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "trialVip",
    extends : generalCmpPart,
    components : {  },
    data () {
        return {
            title : '免费领取会员',
            apiConfig : config.apiConfig,
            phone : '',
            validateIdentifyingCode : ''
        }
    },
    methods : {

    },
    mounted() {

        appHelper.setTitle(this.title);

    }
}
</script>

<style lang="scss" scoped>
.pageBg {
    position: absolute;
    z-index: 1;
    background-color: #442224;
    left: 0;
    top: 0;
    img {
        width: 100%;
        height: auto;
    }
}
.pageContent {
    position: relative;
    z-index: 2;
}
.getCodeButton {
    background: transparent;
    border: none;
    color: #FFB200;

    &:disabled {
        color: #ccc;
    }
}
.submitButton {
    height:48px;
    width: 100%;
    line-height:48px;
    background:linear-gradient(90deg,rgba(254,202,64,1) 0%,rgba(255,147,62,1) 100%);
    border-radius:24px;
    border: none;
}
</style>
